// https://stackoverflow.com/questions/3018313/algorithm-to-convert-rgb-to-hsv-and-hsv-to-rgb-in-range-0-255-for-both
export function hsv2rgb(h, s, v) {

    if(s <= 0.0) {
        return [v, v, v];
    }

    var hh = h;
    if(hh >= 360.0) hh = 0.0;
    hh /= 60.0;
    var i = Math.floor(hh);
    var ff = hh - i;
    var p = v * (1.0 - s);
    var q = v * (1.0 - (s * ff));
    var t = v * (1.0 - (s * (1.0 - ff)));

    switch(i) {
        case 0:
            return [v, t, p];
        case 1:
            return [q, v, p];
        case 2:
            return [p, v, t];
        case 3:
            return [p, q, v];
        case 4:
            return [t, p, v];
        case 5:
        default:
            return [v, p, q];
    }
}

const formatCSSColorComponent = v => {
    const str = Math.max(0, Math.min(255, Math.floor(v * 255))).toString(16);
    return str.length === 2 ? str : "0" + str;
};

export function rgb2css(rgb) {
    return "#" + rgb.map(formatCSSColorComponent).join("");
}

const PHI = -(1 - Math.sqrt(5)) / 2;
export function randomColor(seed, s, v) {
    return hsv2rgb((360 * PHI * seed) % 360, s, v);
}

export function randomColorCSS(seed, s, v) {
    return rgb2css(randomColor(seed, s, v));
}
